module.exports = __webpack_public_path__ + "img/Logo.7d234b10.png";